/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionTypes';

const initialState = {
  planType: [],
  rebateProgramList: [],
  rebateProgramNameValue: '',
  selectedPlanType: '',
  rebateProgrameName: '',
  rebateProgramValue: '',
  errors: [],
  fromDateValue: '',
  toDateValue: '',
  rebateProgramName: '',
  adjustmentSelected: [],
  allAdjustmentGrid: [],
  searchResult: [],
  isLoading: false,
  isAllAdjustmentSelected: true,
  scrollDownManufacturers: true,
  selectedRowIndexValue: '',

  dispalyObj: {
    rebateProgrameName: '',
    rebateProgramValue: '',
    fromDateValue: '',
    toDateValue: '',
    searchResult: [],
    adjustmentSelected: true,
    selectedPlanType: '',
    rebateProgramList: [],
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    case ActionTypes.GET_REBATE_PROGRAM_ADJUSTMENT_REASON_CODE:
      return { ...state, rebateProgramList: action.payload };
    case ActionTypes.SET_SELECTED_INPUT_ADJUSTMENT_REASON_CODE:
      return { ...state, ...action.payload };
    case ActionTypes.IS_LOADING_ADJUSTMENT_REASON_CODE:
      return { ...state, isLoading: action.isLoading };
    case ActionTypes.GET_ALL_ADJUSTMENT_GRID:
      return { ...state, allAdjustmentGrid: action.allAdjustmentGrid };
    case ActionTypes.GET_ADJUSTMENT_REASON_CODE_SEARCH_RESULT:
      let dispalyObj = {
        ...state.dispalyObj,
        searchResult: action.searchResult,
      };
      return { ...state, searchResult: action.searchResult, dispalyObj };
    case ActionTypes.SET_EXPORT_ALL_PDF_ADJUSTMENT_REASON_CODE:
      const { data, drugActivityType } = action.payload;
      const exportAllData =
        drugActivityType === 'noData'
          ? {}
          : { ...state.exportAllData, [drugActivityType]: data };

      return {
        ...state,
        exportAllData,
      };

    case ActionTypes.REFRESH_ADJUSTMENY_CODE_REASON:
      return { ...initialState, dispalyObj: state.dispalyObj };
    case ActionTypes.SET_REFRESH_DATA_REDUX_DETAIL_SCREEN:
      return {
        ...initialState,
        dispalyObj: {
          rebateProgrameName: '',
          rebateProgramValue: '',
          fromDateValue: '',
          toDateValue: '',
          searchResult: [],
          adjustmentSelected: true,
          selectedPlanType: '',
          rebateProgramList: [],
        },
      };
    case ActionTypes.SET_PAGINATION_INDEX_ADJUTMENT_BY_REASON_CODE:
      return {
        ...state,
        dispalyObj: { ...state.dispalyObj, countValue: action.payload },
      };
    default:
      return state;
  }
};

export default reducer;
